import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { EMPTY_ARRAY } from '../../../lib/globals';

import RelationCard from '../../../components/RelationCard/RelationCard';

import useApiErrorsToast from '../../../hooks/api/useApiErrorsToast';
import { useFeaturedImages } from '../../../hooks/api/useFeaturedImages';
import { useRelations } from '../../../hooks/api/useRelations';

const RELATION_HOOK_PARAMS = { limit: 1000, page: 1 };

const CascadeModalContent = ({ references = EMPTY_ARRAY }) => {
  const { t } = useTranslation();

  const { data, isLoading, isFetching, errors } = useRelations(
    references,
    RELATION_HOOK_PARAMS,
  );

  useApiErrorsToast(errors);

  const contentTypes = useMemo(
    () =>
      isLoading || !data
        ? []
        : Object.values(data).map(({ contentType }) => contentType),
    [data, isLoading],
  );

  const [featuredImages, featuredImagesLoading] =
    useFeaturedImages(contentTypes);

  return (
    <>
      <p className="mb-5 text-lg">
        {t(`ObjectStatus.CascadePublish.Content`, {
          count: references.length,
        })}
      </p>
      <div className="flex flex-col items-center space-y-2">
        {Object.entries(data || {}).map(([contentTypeName, relation]) => {
          const relationType = contentTypeName;
          const objects = relation.data ? relation.data : relation;
          const titleField = relation.titleField;

          return objects.map((relation) => (
            <RelationCard
              key={typeof relation === 'string' ? relation : relation.id}
              relation={relation}
              relationType={relationType}
              featuredImageUrl={featuredImages[contentTypeName]}
              featuredImageLoading={featuredImagesLoading}
              titleField={titleField}
              relationsAreLoading={isFetching}
              withObjectStatus
            />
          ));
        })}
      </div>
    </>
  );
};

export default CascadeModalContent;

CascadeModalContent.propTypes = {
  /**
   * Object references
   */
  references: PropTypes.arrayOf(
    PropTypes.shape({
      dataUrl: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
      draftPublic: PropTypes.bool,
    }),
  ),
};
